export default {
	"CountDown.CountdownToTheEvent": "活動倒計時："
}